/** Keeps one broken page from blanking the whole app: shows the error and a retry instead. */
import { Component, type ErrorInfo, type ReactNode } from 'react';
import { log } from '../lib/logger';

interface Props { children: ReactNode; where: string }
interface State { error: Error | null }

export class ErrorBoundary extends Component<Props, State> {
  public override state: State = { error: null };

  public static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  public override componentDidCatch(error: Error, info: ErrorInfo): void {
    log.error('ui.render_failed', { where: this.props.where, error: error.message, stack: info.componentStack?.slice(0, 800) });
  }

  public override render(): ReactNode {
    if (this.state.error === null) return this.props.children;
    return (
      <div className="card" role="alert" style={{ maxWidth: 560 }}>
        <h2 style={{ marginBottom: 8 }}>This page hit a problem</h2>
        <p className="muted" style={{ marginTop: 0 }}>{this.state.error.message}</p>
        <div className="row">
          <button type="button" className="btn btn-primary" onClick={() => this.setState({ error: null })}>Try again</button>
          <button type="button" className="btn" onClick={() => window.location.reload()}>Reload</button>
        </div>
      </div>
    );
  }
}
